// use `name` to register a Functional Component which will become unresolvable
// in production build due to name mangling.
var registerComponent = function registerComponent(Vue, component, name) {
  Vue.component(name || component.name, component);
};
var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
  if (!Vue.config.globalProperties.$buefy) Vue.config.globalProperties.$buefy = {};
  Vue.config.globalProperties.$buefy[property] = component;
};

export { registerComponent as a, registerComponentProgrammatic as r };
